export default __webpack_public_path__ + "static/media/2x.ee388274.png";